import WithGASetup from '../../../components/WithGASetup';
import AuthContext from '../../../context/AuthContext.js';
import MyAccountIntakeFormsPage from './MyAccountIntakeFormsPage.js';

export default WithGASetup(MyAccountIntakeFormsPage, AuthContext);
